var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.69043C5.87695 0.69043 3.55273 1.97871 2.13164 3.95762V2.64277C2.13164 2.2377 1.79961 1.9123 1.39453 1.9123C0.989453 1.9123 0.664062 2.2377 0.664062 2.64277V5.57129C0.664062 5.97637 0.996094 6.30176 1.40117 6.30176H4.58203C4.98711 6.30176 5.31914 5.97637 5.31914 5.57129C5.31914 5.16621 4.98711 4.84082 4.58203 4.84082H3.30703C4.45586 3.21387 6.35508 2.15137 8.5 2.15137C12.0195 2.15137 14.8684 4.99355 14.8684 8.4998C14.8684 12.0061 12.0195 14.8482 8.5 14.8482C5.53828 14.8482 3.05469 12.8295 2.34414 10.0936L2.33086 10.1002C2.23125 9.81465 1.96563 9.60215 1.64023 9.60215C1.23516 9.60215 0.903125 9.92754 0.903125 10.3326C0.903125 10.4057 0.923047 10.4721 0.942969 10.5385H0.936328C0.942969 10.5584 0.949609 10.5717 0.95625 10.5916C0.962891 10.6049 0.962891 10.6182 0.969531 10.6314C1.89922 13.9119 4.90742 16.3158 8.49336 16.3158C12.823 16.3158 16.3293 12.8162 16.3293 8.50645C16.3359 4.1834 12.8297 0.69043 8.5 0.69043ZM8.5 3.98418C8.09492 3.98418 7.76289 4.30957 7.76289 4.71465V9.11074C7.76289 9.51582 8.09492 9.84121 8.5 9.84121H11.6809C12.0859 9.84121 12.418 9.51582 12.418 9.11074C12.418 8.70566 12.0859 8.38027 11.6809 8.38027H9.23047V4.71465C9.23711 4.30957 8.90508 3.98418 8.5 3.98418Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.6abc2ab5fc91ecfdc24a566c661b9afb.svg";
export { ForwardRef as ReactComponent };